<app-cargosprint-logo [variant]="LogoVariant.WHITE" [orientation]="LogoOrientation.VERTICAL"></app-cargosprint-logo>